
import theme from '../../constants/theme';

const SI = 'https://cdn.simpleicons.org';

const techStack = [
  { name: 'PyTorch',        src: `${SI}/pytorch` },
  { name: 'TensorFlow',     src: `${SI}/tensorflow` },
  { name: 'OpenAI',         src: `https://images.icon-icons.com/3913/PNG/512/openai_logo_icon_248315.png` },
  { name: 'HuggingFace',    src: `${SI}/huggingface` },
  { name: 'Android Edge',   src: `${SI}/android` },
  { name: 'AWS',            src: `https://raw.githubusercontent.com/lobehub/lobe-icons/refs/heads/master/packages/static-png/light/aws.png` },
  { name: 'LangChain',      src: `${SI}/langchain` },
  { name: 'n8n',            src: `${SI}/n8n` },
  { name: 'Docker',         src: `${SI}/docker` },
  { name: 'GitHub',         src: `${SI}/github` },
  { name: 'Spring Boot',    src: `${SI}/springboot` },
  { name: 'React',          src: `${SI}/react` },
  { name: 'Angular',        src: `${SI}/angular` },
  { name: 'Vue',            src: `${SI}/vuedotjs` },
];

// Drop in your actual logo URLs/imports for clients once you have them.
// For now, text badges are shown as fallback.
const clients = [
  { name: 'Ultimus',        src: 'https://www.ultimus.com/hubfs/Logos/Ultimus%20Logos/Ultimus%20CPS%20Logos/Ultimus%20CPS%20Logo-%20Horizontal%20Blue%20with%20border.png' },
  { name: 'Measmerize',     src: 'https://www.measmerize.com/measmerize_logo.png' },
  { name: 'SNIPBACK AI',    src: 'https://snipback.com/assets/images/home/logo-dark.png' },
  { name: 'Altaif Group',   src: 'https://www.altaif.co/wp-content/uploads/2024/04/Al-Taif-Holding-Logo-03-1536x726.png' },
  { name: 'DAY 1 COMPANY',  src: 'https://cdn.imweb.me/thumbnail/20260330/1b887f2f5b24b.png' },
  { name: 'healthhub',      src: 'https://media.licdn.com/dms/image/v2/D560BAQFECji02mZsLQ/company-logo_200_200/B56ZVeWU0xGUAI-/0/1741044666022/healthhub_kr_logo?e=1776902400&v=beta&t=PN2jJf9RWA5iq1dkyAbxInPGxLVqrQ8rHRzQgbBrX0Q' },
];

function LogoItem({ item, imgStyle }) {
  return (
    <>
      {item.src ? (
        <img
          src={item.src}
          alt={item.name}
          title={item.name}
          style={imgStyle}
          className="logo-img"
        />
      ) : (
        <span
          style={{
            fontWeight: 800,
            fontSize: '15px',
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            opacity: 0.55,
            color: theme.text,
          }}
        >
          {item.name}
        </span>
      )}
      <span style={{ color: theme.primary, fontSize: '20px' }}>•</span>
    </>
  );
}

function MarqueeRow({ items, speed = '30s', imgHeight = 32, className = '' }) {
  const doubled = [...items, ...items];

  const imgStyle = {
    height: `${imgHeight}px`,
    width: 'auto',
    maxWidth: '120px',
    objectFit: 'contain',
    filter: 'grayscale(1) opacity(1)',
    transition: 'filter 0.25s ease',
  };

  return (
    <div className={`overflow-hidden whitespace-nowrap ${className}`}>
      <div
        className="inline-flex items-center gap-12 px-6"
        style={{ animation: `marquee ${speed} linear infinite` }}
      >
        {doubled.map((item, i) => (
          <div key={i} className="flex items-center gap-12">
            <LogoItem item={item} imgStyle={imgStyle} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default function Marquees() {
  return (
    <>
      {/* Keyframe injection — put this in your global CSS instead */}
      <style>{`
        @keyframes marquee {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }
        .logo-img:hover {
          filter: grayscale(0) opacity(1) !important;
        }
      `}</style>

      {/* Tech Stack Marquee */}
      <section
        className="py-6 border-b overflow-hidden"
        style={{ borderColor: 'rgba(198,6,100,0.1)', backgroundColor: 'white' }}
      >
        <MarqueeRow items={techStack} speed="30s" imgHeight={32} />
      </section>

      {/* Clients Marquee */}
      <section
        id="clients"
        className="py-24 border-t"
        style={{ borderColor: 'rgba(198,6,100,0.1)', backgroundColor: theme.bg }}
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12 mb-12 text-center">
          <h2
            className="font-retropix text-3xl md:text-4xl mb-4"
            style={{ color: theme.primary }}
          >
            Trusted By
          </h2>
          <p className="opacity-80 max-w-2xl mx-auto">
            Startups, MNCs, and innovative teams pushing the boundaries of AI.
          </p>
        </div>

        <div
          className="py-8 bg-white border-y shadow-sm overflow-hidden"
          style={{ borderColor: 'rgba(198,6,100,0.1)' }}
        >
          <MarqueeRow items={clients} speed="40s" imgHeight={40} />
        </div>
      </section>
    </>
  );
}